module.exports = __webpack_public_path__ + "static/media/instagram-white.2e0b0067.svg";